import React from 'react';
import { useTranslation } from 'react-i18next';

function SwisscoverysearchPlaceholder() {
  // calling useTranslation without a namespace will load keys from
  // the default translations. Provided by default are a 'loading...' key
  // as well as a set of time and date specific keys.
  // see @ktag/styleguide/src/javascripts/i18n/translation.js
  const { t } = useTranslation('');

  return (
    <div className="swisscoverysearch__placeholder">
      <span className="swisscoverysearch__placeholder-label">{t('loading...')}</span>
      <div className="swisscoverysearch__placeholder-element" />
    </div>
  );
}

export default SwisscoverysearchPlaceholder;
